import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  TablePagination,
} from "@mui/material";
import { CloudDownload } from "@mui/icons-material";
import axios from "axios";

const DynamicTable2 = ({ columns, data, pdfColumn, apiEndpoint }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  // Handle page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Handle rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Function to open PDF
  const handleOpenPDF = async (fileName) => {
    try {
      const response = await axios.get(`${apiEndpoint}/${fileName}`, {
        responseType: "blob",
      });

      // Create a blob URL and open in new tab
      const pdfBlob = new Blob([response.data], { type: "application/pdf" });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      window.open(pdfUrl, "_blank");
    } catch (error) {
      console.error("Error fetching PDF:", error);
    }
  };

  return (
    <TableContainer sx={{ maxHeight: 400 }}>
      <Table size="small" stickyHeader>
        <TableHead>
          <TableRow>
            {columns.map((col, index) => (
              <TableCell
                key={index}
                sx={{ fontWeight: "bold", whiteSpace: "nowrap" }}
              >
                {col.header}
              </TableCell>
            ))}
            {pdfColumn && (
              <TableCell sx={{ fontWeight: "bold" }}>Action</TableCell>
            )}
          </TableRow>
        </TableHead>
        <TableBody>
          {data
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {columns.map((col, colIndex) => (
                  <TableCell key={colIndex} sx={{ whiteSpace: "nowrap" }}>
                    {row[col.field]}
                  </TableCell>
                ))}
                {pdfColumn && (
                  <TableCell>
                    {row[pdfColumn] &&
                      row[pdfColumn].split("X").map((link, index) => (
                        <Button
                          key={index}
                          size="small"
                          variant="contained"
                          color="primary"
                          startIcon={<CloudDownload />}
                          onClick={() => window.open(link.trim(), "_blank")}
                          style={{ marginRight: "5px" }}
                        >
                          View {index + 1}
                        </Button>
                      ))}
                  </TableCell>
                )}
              </TableRow>
            ))}
        </TableBody>
      </Table>
      <TablePagination
        component="div"
        count={data.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        rowsPerPageOptions={[5, 10, 20]}
      />
    </TableContainer>
  );
};

export default DynamicTable2;
